import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";

import * as AddToCartTracker from "../../trackers/feature/addToCart.tracker";
import * as RemoveFromCartTracker from "../../trackers/feature/removeFromCart.tracker";

export const trackCartItem = (cartItem: CartItem, quantityDelta: number) => {
    const isAddToCart = quantityDelta > 0;
    const quantity = Math.abs(quantityDelta);

    if (isAddToCart) {
        AddToCartTracker.trackCartItem(cartItem, quantity);
    } else {
        RemoveFromCartTracker.trackCartItem(cartItem, quantity);
    }
};
